import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'semantic-ui-css/semantic.min.css'
import 'katex/dist/katex.min.css';

ReactDOM.render(<App />, document.getElementById('root'));

serviceWorker.unregister();



// WEBPACK FOOTER //
// ./src/index.js